import getMotion from '@cartwhl/common/api/getMotion';

import { DEFAULT_CHARACTER } from '../MotionEditor/constants';

export type AssetLibraryStockMotionPreviewState = {
  status: 'idle' | 'pending' | 'ready' | 'error';
  motionId: string | null;
  title: string | null;
  bvhURL: string | null;
  error?: string;
};

export const INITIAL_STOCK_MOTION_PREVIEW_STATE: AssetLibraryStockMotionPreviewState =
  {
    status: 'idle',
    motionId: null,
    title: null,
    bvhURL: null,
  };

export async function fetchStockMotionPreviewBvhURL(
  motionID: string,
  apiKey: string,
  signal?: AbortSignal,
): Promise<string> {
  const { data, error } = await getMotion(
    motionID,
    apiKey,
    {
      characterID: DEFAULT_CHARACTER.jobID,
      downloadType: 'bvh',
      fps: 30,
      frameStep: 1,
      rootMotion: false,
    },
    signal,
  );

  if (error || !data) {
    throw new Error(error?.message ?? 'Unable to load motion preview.');
  }

  if (data.status !== 'COMPLETED') {
    throw new Error('Motion is not ready to preview.');
  }

  const bvhURL = data.bvhURL?.trim();
  if (!bvhURL) {
    throw new Error('Motion preview is unavailable.');
  }

  return bvhURL;
}
